export default __webpack_public_path__ + "static/media/Feature3.aee3d9ad.svg";